import { StripePriceLookupKey } from '@paragon/contract-library';
import { userService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';

import { getLoggedInUser } from '../selectors/users';
import { AsyncThunkActionReturn, AsyncThunkActionVoid } from '../thunkActions';

export function upgradeToPlan(
  stripePriceLookupKey: StripePriceLookupKey,
  successUrl: string,
  cancelUrl: string,
): AsyncThunkActionVoid {
  return async function upgradeToStandardPlanThunkAction(dispatch, getState) {
    const loggedInUser = getLoggedInUser(getState());
    if (!loggedInUser) return;

    try {
      const { checkoutUrl } = await userService.organizations.checkout(stripePriceLookupKey, successUrl, cancelUrl);
      window.open(checkoutUrl, '_self');
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Failed to upgrade account. Contact help@paragontruss.com for assistance.'));
    }
  };
}

export function cancelSubscription(): AsyncThunkActionReturn<boolean> {
  return async function cancelSubscriptionThunkAction(dispatch, getState) {
    const loggedInUser = getLoggedInUser(getState());
    if (!loggedInUser) return false;

    try {
      await userService.organizations.cancelSubscription();
      return true;
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Failed to cancel subscription. Contact help@paragontruss.com for assistance.'));
      return false;
    }
  };
}

export function uncancelSubscription(): AsyncThunkActionReturn<boolean> {
  return async function uncancelSubscriptionThunkAction(dispatch, getState) {
    const loggedInUser = getLoggedInUser(getState());
    if (!loggedInUser) return false;

    try {
      await userService.organizations.uncancelSubscription();
      return true;
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Failed to cancel downgrade. Contact help@paragontruss.com for assistance.'));
      return false;
    }
  };
}

export function startFreeTrial(successUrl: string): AsyncThunkActionVoid {
  return async function startFreeTrialThunkAction(dispatch, getState) {
    const loggedInUser = getLoggedInUser(getState());
    if (!loggedInUser) return;

    try {
      await userService.users.startFreeTrial();
      window.open(successUrl, '_self');
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Failed to start free trial. Contact help@paragontruss.com for assistance.'));
    }
  };
}
